import Pointsdropdown from "../models-dropdown";
import CloseIcon from '@mui/icons-material/Close';
import { Radio } from "@mui/material";

function TableRows(
  {
    modelDropDownOptions,
    rowsData,
    deleteTableRows,
    handleAlertStartTimeChange,
    handleAlertEndTimeChange,
    handlePointsChange,
    handleDetectionTypeChange,
    handleSelectRowChange,
    handleDirectionChange,
    handleFullRegionTypeChange,
    handleDistanceChange,
    setModelCriteria,
    handleShowAllChange
  }) {

  return rowsData?.map((data, index) => {
    return (
      <tr key={index}>
        <td>
          <Radio
            checked={data?.is_selected}
            onChange={(event) => handleSelectRowChange(index, event.target.value)}
            value={true}
            name={"radio-buttons-" + index}
            inputProps={{ "aria-label": "A" }}
            sx={{
              color: '#102747',
              "&.Mui-checked": {
                color: '#102747',
              },
            }}
          />{" "}
        </td>
        <td width={300}>
          <Pointsdropdown
            name={"assign_" + index}
            className="form-control"
            modelDropDownOptions={modelDropDownOptions}
            selectedOptions={[data?.model]}
            setSelectedOptions={(selectedOption) => handlePointsChange(selectedOption, index)}
            setModelCriteria={(modelCriteria) => setModelCriteria(index, modelCriteria)}
            isSingleSelect={true}
          />
        </td>
        <td>
          {
            <>
              {
                (
                  data?.is_draw_line ||
                  data?.is_polygon_region ||
                  data?.is_draw_line ||
                  data?.is_start_end_line
                )
                  ?
                  (
                    <>
                      <div className="d-flex">
                        <Radio 
                          checked={data?.is_show_all}
                          onChange={(event) => handleShowAllChange(index, event.target.checked)}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                          sx={{
                            color: '#102747',
                            "&.Mui-checked": {
                              color: '#102747',
                            },
                          }}
                        />{""}
                        <span className="mt-2">Show All</span>
                      </div>
                    </>
                  )
                  :
                  (
                    <></>
                  )
              }

              {
                data?.is_polygon_region || data?.is_full_region ?
                  (<>
                    <div className="d-flex">
                      <Radio
                        checked={data?.is_full_or_region_selected}
                        onChange={(event) => handleDetectionTypeChange(index, "is_full_or_region_selected", event.target.checked)}
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        sx={{
                          color: '#102747',
                          "&.Mui-checked": {
                            color: '#102747',
                          },
                        }}
                      />{""}
                      <span className="mt-2">Full/Region</span>
                    </div>
                  </>
                  )
                  :
                  (<></>)
              }
              {
                data?.is_draw_line ?
                  (<div className="d-flex">
                    <Radio
                      checked={data?.is_draw_line_selected}
                      onChange={(event) => handleDetectionTypeChange(index, "is_draw_line_selected", event.target.checked)}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      sx={{
                        color: '#102747',
                        "&.Mui-checked": {
                          color: '#102747',
                        },
                      }}
                    />{""}
                    <span className="mt-2">Line</span>
                  </div>)
                  :
                  (
                    <></>
                  )
              }
              {
                data?.is_select_direction ?
                  (<div className="d-flex">
                    <Radio
                      checked={data?.is_select_direction_selected}
                      onChange={(event) => handleDetectionTypeChange(index, "is_select_direction_selected", event.target.checked)}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      sx={{
                        color: '#102747',
                        "&.Mui-checked": {
                          color: '#102747',
                        },
                      }}
                    />{""}
                    <span className="mt-2">Direction</span>
                  </div>)
                  :
                  (
                    <></>
                  )
              }
              {
                data?.is_start_end_line ?
                  (
                    <>
                      <div className="d-flex">
                        <Radio
                          checked={data?.is_start_line_selected}
                          onChange={(event) => handleDetectionTypeChange(index, "is_start_line_selected", event.target.checked)}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                          sx={{
                            color: '#102747',
                            "&.Mui-checked": {
                              color: '#102747',
                            },
                          }}
                        />{""}
                        <span className="mt-2">Start Line</span>
                      </div>
                      <div className="d-flex">
                        <Radio
                          checked={data?.is_end_line_selected}
                          onChange={(event) => handleDetectionTypeChange(index, "is_end_line_selected", event.target.checked)}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                          sx={{
                            color: '#102747',
                            "&.Mui-checked": {
                              color: '#102747',
                            },
                          }}
                        />{""}
                        <span className="mt-2">End Line</span>
                      </div>
                    </>
                  )
                  :
                  (
                    <></>
                  )
              }
              {
                (
                  !data?.is_draw_line &&
                  !data?.is_polygon_region &&
                  !data?.is_draw_line &&
                  !data?.is_select_direction &&
                  !data?.is_start_end_line
                )
                  ?
                  (
                    <>
                      -
                    </>
                  )
                  :
                  (
                    <></>
                  )
              }
            </>
          }
        </td>
        <td>
          {
            data?.is_select_direction && data?.is_select_direction_selected ?
              (
                <>
                  <div className="d-flex">
                    <Radio
                      checked={data?.direction === "up"}
                      onChange={(event) => handleDirectionChange(index, event.target.value)}
                      value={"up"}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      sx={{
                        color: '#102747',
                        "&.Mui-checked": {
                          color: '#102747',
                        },
                      }}
                    />{""}
                    <span className="mt-2">Up</span>
                  </div>
                  <div className="d-flex">
                    <Radio
                      checked={data?.direction === "down"}
                      onChange={(event) => handleDirectionChange(index, event.target.value)}
                      value={"down"}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      sx={{
                        color: '#102747',
                        "&.Mui-checked": {
                          color: '#102747',
                        },
                      }}
                    />{""}
                    <span className="mt-2">Down</span>
                  </div>
                </>
              )
              :
              (
                <>
                  {
                    (data?.is_polygon_region || data?.is_full_region) && data?.is_full_or_region_selected ?
                      (
                        <>
                          <div className="d-flex">
                            <Radio
                              checked={data?.is_full_region_selected}
                              onChange={(event) => handleFullRegionTypeChange(index, "is_full_region_selected", event.target.checked)}
                              name="radio-buttons"
                              inputProps={{ "aria-label": "A"}}
                              sx={{
                                color: '#102747',
                                "&.Mui-checked": {
                                  color: '#102747',
                                },
                              }}
                            />{""}
                            <span className="mt-2">Full</span>
                          </div>
                          <div className="d-flex">
                            <Radio
                              checked={data?.is_polygon_region_selected}
                              onChange={(event) => handleFullRegionTypeChange(index, "is_polygon_region_selected", event.target.checked)}
                              name="radio-buttons"
                              inputProps={{ "aria-label": "A" }}
                              sx={{
                                color: '#102747',
                                "&.Mui-checked": {
                                  color: '#102747',
                                },
                              }}
                            />{""}
                            <span className="mt-2">Region</span>
                          </div>
                        </>
                      )
                      :
                      (
                        <>
                          {
                            data?.is_start_end_line && (data?.is_start_line_selected || data?.is_end_line_selected) ?
                              (
                                <>
                                  <form>
                                    <div><label className="label-fields large-text" style={{width:150, fontSize:'18px', marginTop:'00px'}}>Enter Distance</label></div>
                                    <label style={{margin:'5px'}}>
                                    <input
                                        style={{width:120, height:'40px', padding:'10px'}}
                                        type="number"
                                        id="distance"
                                        placeholder="Enter distance"
                                        min="0"
                                        value={data?.distance}
                                        onChange={(e) => handleDistanceChange(index, e.target.value)}
                                        autoComplete="off"
                                      />
                                    </label>
                                  </form>
                                </>
                              )
                              :
                              (<>-</>)
                          }
                        </>
                      )
                  }
                </>
              )
          }
        </td>
        <td width={200}>
          <div className="label-input">
            <label className="label-fields larger-text" style={{width:150, fontSize:'18px'}}>Start Time</label>
            <input
              className="input-fields large-text"
              style={{width:150}}
              type="time"
              name={"alert_start_time"}
              onChange={(value) => handleAlertStartTimeChange(index, value)}
              value={[data?.alert_start_time]}
            />
          </div>
          <div className="label-input">
            <label className="label-fields large-text" style={{width:150, fontSize:'18px'}}>End Time</label>
            <input
              className="input-fields large-text"
              style={{width:150}}
              type="time"
              name={"alert_end_time"}
              onChange={(value) => handleAlertEndTimeChange(index, value)}
              value={[data?.alert_end_time]}
            />
          </div>
        </td>
        <td width={50}>
          <button
            className="close"
            onClick={() => deleteTableRows(index)}
          >
            <CloseIcon fontSize="small" />
          </button>
        </td>
      </tr>
    );
  });
}

export default TableRows;